import React from 'react';

const TableHeader = () => {
	return (
		<div className='table__header'>
			<p className='table__header__name'>name</p>
			<p className='table__header__status'>status</p>
		</div>
	);
};

export default TableHeader;
